<template>
    <v-container
        v-if="assessment"
        class="abstract-container lm-border pa-3"
        style="height: calc(100% - 90px);"
    >
        <div class="v-flex w-100">
            <div>
                <div class="abstract-prev-step">1a</div>
                <div class="abstract-prev-bar"></div>
            </div>
            <div class="abstract-panel" style="overflow: hidden">
                <div class="abstract-group" style="height: 150px; margin-bottom: 15px">
                    <f-title :title="assessment.type ? assessment.type.name : '---'" />

                    <div class="ro-background pa-3">
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame col-5">
                                Prüfungsergebnis:
                            </v-col>
                            <v-col class="no-frame col-7" v-if="assessment.result">
                                {{ assessment.result ? assessment.result.name : '---' }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame col-5">
                                Datum der Prüfung:
                            </v-col>
                            <v-col class="no-frame col-7">
                                {{ dateAsString( assessment.dateAssessment )}}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame col-5">
                                Nächste Prüfung:
                            </v-col>
                            <v-col class="no-frame col-7">
                                {{ dateAsString(assessment.dateNextAssessment) }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame col-5">
                                Nachprüfung bis:
                            </v-col>
                            <v-col class="no-frame col-7">
                                {{ dateAsString(assessment.dateRemedyOfDefects) }}
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="abstract-group" style="margin-bottom: 0; padding-bottom: 4px">
                    <v-row class="no-frame abstract-info">
                        <v-col class="no-frame">
                            <v-row
                                class="no-frame"
                            >
                                <v-col class="no-frame">
                                    <c-contract-zus-abstract/>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>

                <div class="abstract-group" style="height: 154px; margin-bottom: 0!important;">
                    <f-title title="Kontakt" />

                    <div class="ro-background pa-3">
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame">
                                {{ assessment.contactName ? assessment.contactName : '---' }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame">
                                {{ assessment.contactPhone ? assessment.contactPhone : '---' }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame">
                                {{ assessment.contactMobile ? assessment.contactMobile : '--' }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame abstract-info">
                            <v-col class="no-frame">
                                {{ assessment.contactMail ? assessment.contactMail : '---'}}
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import moment from "moment";
import FTitle from "@/modules/core/components/utils/FTitle.vue";
import CContractZusAbstract from "@/modules/msd/company/contract/components/controls/zus/CContractZusAbstract.vue";

export default {
    name: "IncAssessmentAbstract",
    components: {
        CContractZusAbstract,
        FTitle
    },

    props: {
        assessment: {

        }
    },

    methods: {
        dateAsString(value) {
            if (value === null || value === "") {
                return "";
            }
            return moment( value, "YYYY-MM-DD").format("DD.MM.YYYY")
            //return DateTime.date(value);
        },
    }
}
</script>

<style src="../../../../../assets/css/abstract.css">
</style>